import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  isCreating, isError, ResourcesItem, ResourcesList,
} from 'redux-and-the-rest';

import { IslandModel } from '../../../models/islandModel';
import { getOrFetchIslands } from '../../../redux/reducers/islandReducer';
import { ApplicationState } from '../../../redux/types';
import IslandTile from './IslandTile';
import Env from '../../../utils/env';
import { Routes } from '../../../routes';
import { getUser } from '../../../redux/reducers/userReducer';
import { UserModel } from '../../../models/userModel';

const { TEACHER_PORTAL } = Env;

interface Props {
  islands: ResourcesList<IslandModel>
  onSelectIsland?: (islandId: string) => void
  selectedIslandId?: string;
  user: ResourcesItem<UserModel>
}

const IslandList = ({
  islands: { items }, onSelectIsland, selectedIslandId, user,
}: Props): React.ReactElement => {
  if (items.length === 0) {
    if (TEACHER_PORTAL) {
      return (
        <Redirect to={Routes.NoIslands} />
      );
    }
    return (
      <div className="list empty">
        <span>
          No items to display
        </span>
      </div>
    );
  }

  return (
    <div className="list island-list">
      {items
        // Ensure items that are in-flight creating are not imediately included in the list
        .filter((island: ResourcesItem<IslandModel>) => !isCreating(island) && !isError(island))
        .map((island: ResourcesItem<IslandModel>) => {
          const { values: { id } } = island;
          const selected = selectedIslandId && selectedIslandId === id;

          const classNames = [
            'list-item',
            selected ? 'selected' : undefined,
          ];

          return (
            <div
              className={classNames.join(' ')}
              key={island.values.id}
            >
              <IslandTile onSelectIsland={onSelectIsland} island={island} user={user} />
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = ({ islands, users }: ApplicationState) => ({
  islands: getOrFetchIslands(islands),
  user: getUser(users),
});

export default connect(mapStateToProps)(IslandList);
